export default "__VITE_ASSET__6661d80c__"